﻿import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import backend from "i18next-xhr-backend";

// IMPORT: Translation-files
import translationSV from '../Locale/sv/translation.json';
import translationEN from '../Locale/en/translation.json';

// TRANSFERING: Translations to resources
const resources = {
    sv: {
        translation: translationSV
    },
    en: {
        translation: translationEN
    }
};

i18n
    .use(backend)
    .use(initReactI18next)
    .init({
        resources,
        lng: "sv",
        fallbackLng: "sv",
        keySeparator: true, // we do use keys in form messages.welcome
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;